import React, { useState } from 'react'

import _ from 'lodash'
import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import '../../index.scss'
import LtsLookup from './lts-lookup'
import { InputText } from 'primereact/inputtext'

export default function LtsLookupDocumento(props) {
  const [filters, setFilters] = useState([])

  const columns = [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: false,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'nome',
      header: 'Nome',
      columnKey: 'nome',
      columnSortField: 'nome',
      sortable: true,
      filter: true,
      visible: true,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post(`/lottustech/documentos/all`, params)
  }

  const onKeyPress = (e) => {
    const value = _.get(props, 'value', null)
    if (value) {
      const descricao = _.get(value, 'nome', null)
      const filters = [new Filtro('nome', descricao, 'CONTEM')]
      setFilters(filters)
    }
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    if (oid) {
      return `${routes.PATH_DOCUMENTO}/${oid}`
    } else {
      return `${routes.PATH_DOCUMENTO}/novo`
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({
        oid: '',
        nome: value,
      })
    } else {
      props.onChange(value)
    }
  }

  const autoCompleteTemplate = (data) => {
    return `${data.oid} - ${data.nome}`
  }

  const onResolvingColumn = () => {
    return columns.map((col) => {
      // Remove props that should not be spread to DOM elements
      const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

      if (col.field === 'oid') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-codigo-body-width"
            filterHeaderClassName="column-codigo-filter-header-width"
            headerClassName="column-codigo-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      if (col.field === 'nome') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-descricao-body-width"
            filterHeaderClassName="column-descricao-filter-header-width"
            headerClassName="column-descricao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      return null
    })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    return filters
  }

  return (
    <React.Fragment>
      <LtsLookup
        label={props.label}
        value={props.value}
        name={props.name}
        field={props.field}
        history={props.history}
        autoCompleteTemplate={autoCompleteTemplate}
        onKeyPress={onKeyPress}
        onInputFilter={onInputFilter}
        pathOnEditFn={pathOnEditFn}
        header={props.label}
        columns={columns}
        onResolvingColumn={onResolvingColumn}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        onChange={props.onChange}
        filters={filters}
        setFilters={setFilters}
        editDisabled={props.editDisabled}
        editHidden={props.editHidden}
      />
    </React.Fragment>
  )
}
